// 获取钱包接口
import { useState, useEffect } from "react";
import { getPermissionApi } from "@/api/organization";
import { useOrganization } from "@clerk/clerk-react";
import {
  DEFAULT_LANGUAGE,
  SupportedLanguage,
} from "@/i18n";

const parseApiLanguage = (apiLanguage: string | null | undefined): SupportedLanguage | null => {
  if (!apiLanguage) {
    return null;
  }

  if (apiLanguage === "zh" || apiLanguage === "zh-CN") {
    return "zh-CN";
  }

  if (apiLanguage === "en" || apiLanguage === "en-US") {
    return "en-US";
  }

  return DEFAULT_LANGUAGE;
};

const useUserPermission = () => {
  const { organization } = useOrganization();
  const [isHasTodoList, setTodoList] = useState(null);
  const [isAdmin, setAdmin] = useState(false);
  const [canSetMaxCpm, setCanSetMaxCpm] = useState(false);
  const [apiLanguage, setApiLanguage] = useState<SupportedLanguage | null>(null);
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);
  const [canSetInvitesSendingMode, setCanSetInvitesSendingMode] =
    useState(false);

  useEffect(() => {
    if (!organization?.id) {
      setIsLanguageLoaded(true);
      return;
    }

    const fetchData = async () => {
      try {
        const { data } = await getPermissionApi();
        setTodoList(
          data?.isAdmin || data?.isAdsMaster || data?.orgHasAdsMaster
        );
        setAdmin(data?.isAdmin);
        setCanSetMaxCpm(data?.canSetMaxCpm);
        setCanSetInvitesSendingMode(data?.canSetInvitesSendingMode || false);
        setApiLanguage(parseApiLanguage(data?.language));
        setIsLanguageLoaded(true);
      } catch (err: any) {
        // message.error(`${err}`);
        setIsLanguageLoaded(true);
      }
    };
    fetchData();
  }, [organization?.id]);

  // 提供一个更新语言的函数
  const updateLanguage = (newLanguage: SupportedLanguage) => {
    setApiLanguage(newLanguage);
  };

  return {
    isHasTodoList,
    isAdmin,
    canSetMaxCpm,
    apiLanguage,
    updateLanguage,
    isLanguageLoaded,
    canSetInvitesSendingMode,
  };
};

export default useUserPermission;
